import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
	clearSelectedClient,
	clearSelectedAccountant,
	clearSelectedTaxYear,
} from "../../../store/actions";

export const AccountantListRoutesComponent = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clearClientId = () => {
		dispatch(clearSelectedClient());
	};
	const clearClientName = () => {
		// dispatch(clearSelectedClientName());
		dispatch(clearSelectedClient());
	};
	const clearAccountantId = () => {
		dispatch(clearSelectedAccountant());
	};
	const clearAccountantName = () => {
		// dispatch(clearSelectedAccountantName());
		dispatch(clearSelectedAccountant());
	};
	const clearTaxYear = () => {
		dispatch(clearSelectedTaxYear());
	};
	const ArrayData = [
		{
			label: "Home",
			// icon: <HomeOutlinedIcon />,
			expanded: true,
			items: [
				{
					label: "Accountant List",
					command: () => {
						navigate("/accountants");
						clearAccountantId();
						clearAccountantName();
						clearClientId();
						clearClientName();
						clearTaxYear();
						// clearRefNo();
					},
				},
			],
		},
		// {
		// 	label: "Logout",
		// 	// icon: <LogoutOutlinedIcon />,
		// 	command: () => {
		// 		navigate("/logout");
		// 	},
		// },
	];
	return {
		AccountantListRoutes: ArrayData,
	};
};
